document.addEventListener("DOMContentLoaded", async () => {
	const {initSwiperCarousel} = await import("@utils/swiperCarousel");

	const options = {
		pagination: {
			el: ".b-client_testimonials-pagination",
			clickable: true,
		},
		slidesPerView: 1,
		breakpoints: {
			768: {
				slidesPerView: 2, // 2 slides for screens 640px and up
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3, // 3 slides for screens 1024px and up
				spaceBetween: 40,
			},
		},
	};

	initSwiperCarousel(options, ".b-client_testimonials-list_wrapper", true, false)

	const { initPopup } = await import("@utils/popup");
	initPopup();
});
